import { Record } from "../../fable_modules/fable-library-js.4.19.3/Types.js";
import { record_type, lambda_type, unit_type, string_type } from "../../fable_modules/fable-library-js.4.19.3/Reflection.js";

export class ScreenshotProps extends Record {
    constructor(onScreenshotCaptured) {
        super();
        this.onScreenshotCaptured = onScreenshotCaptured;
    }
}

export function ScreenshotProps_$reflection() {
    return record_type("RAWMap.Client.Visualization.Screenshot.Bindings.ScreenshotProps", [], ScreenshotProps, () => [["onScreenshotCaptured", lambda_type(string_type, unit_type)]]);
}

